export const replyIconWidth = 26;
export const avatarWidth = 38;
